import { render, staticRenderFns } from "./TbProductsRank.vue?vue&type=template&id=3d79669e&scoped=true"
import script from "./TbProductsRank.vue?vue&type=script&lang=js"
export * from "./TbProductsRank.vue?vue&type=script&lang=js"
import style0 from "./TbProductsRank.vue?vue&type=style&index=0&id=3d79669e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79669e",
  null
  
)

export default component.exports